import React from "react";
import Header from '../Header/Header';
import Footer from "../Header/Footer";

const RefundPolicy = () => {
  return (
    <div><Header/>
    <div style={{ padding: "80px" }}>
      <h1>Refund Policy</h1>
      <p>
        At <b>Bhantham Matrimony</b>, we strive to provide the best possible
        services to our members. Please note that:
      </p>
      <p style={{ marginTop: "15px", fontWeight: "bold", color: "red" }}>
        We do not provide any refund for any of our services.
      </p>
      <p style={{ marginTop: "15px" }}>
        By registering or availing any of our services, you acknowledge and
        agree to this no-refund policy. We encourage all members to carefully
        read our terms and conditions before making any payments.
      </p>
    </div>
    <Footer/>
    </div>
  );
};

export default RefundPolicy;
